import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import ReportActionsMenu from './ReportActionsMenu';
import { PURCHASE_DOCUMENT_TYPES, SALES_DOCUMENT_TYPES } from '../../dashboard/components/documentTypeConstants';
import CustomPagination from '../../../components/customPagination';
import { formatDate } from '../../../utils/formatDate';
import dayjs from 'dayjs';

const allDocumentTypes = [...SALES_DOCUMENT_TYPES, ...PURCHASE_DOCUMENT_TYPES].reduce((acc, type) => {
  acc[type.id] = type.label;
  return acc;
}, {});

const getDocumentTypeLabel = (typeId) => allDocumentTypes[typeId] || typeId;

const getStatusLabel = (status) => {
  if (!status) return ' ';

  const statusMap = {
    draft: 'Consolidated',
    active: 'E-Invoice',
    aiextraction: 'AI-Extraction',
  };

  return statusMap[status.toLowerCase()] || status;
};

const getReportStatusLabel = (status) => {
  const statusMap = {
    processed: 'Completed',
    failed: 'Failed',
    processing: 'Processing',
    queued: 'Queued',
  };

  return statusMap[status];
};
const ReportTable = ({ reports, loading, totalReports, page, limit, onPageChange, onPageSizeChange }) => {
  const columns = [
    {
      field: 'created_at',
      headerName: 'Request Date',
      flex: 0.7,
      align: 'left',
      renderCell: (params) => dayjs.unix(params.row.created_at).format('YYYY-MM-DD hh:mm:ss A'),
    },
    {
      field: 'filters.status',
      headerName: 'Report Type',
      flex: 0.8,
      align: 'left',
      renderCell: (params) => getStatusLabel(params.row.filters?.status),
    },
    {
      field: 'filters.document_type',
      headerName: 'Document Type',
      flex: 0.8,
      align: 'left',
      renderCell: (params) => getDocumentTypeLabel(params.row.filters?.document_type) || '',
    },
    {
      field: 'period',
      headerName: 'Period',
      flex: 1,
      align: 'left',
      renderCell: (params) => {
        const start = formatDate(params.row.filters?.start_date) || '';
        const end = formatDate(params.row.filters?.end_date) || '';
        return `${start} to ${end}`;
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.6,
      align: 'left',
      id: 'report-status',
      renderCell: (params) => getReportStatusLabel(params.row.status.toLowerCase()),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        const isProcessed = params.row.status?.toLowerCase() === 'processed';
        return <ReportActionsMenu filePath={params.row.file_path} disabled={!isProcessed} />;
      },
    },
  ];

  return (
    <DataGrid
      columns={columns}
      rows={reports}
      getRowId={(row) => row._id}
      sx={{ mt: '1rem' }}
      disableRowSelectionOnClick={true}
      loading={loading}
      paginationMode="server"
      rowCount={totalReports}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: limit,
          },
        },
      }}
      pageSizeOptions={[10, 25]}
      onPaginationModelChange={({ page, pageSize }) => {
        onPageChange(page);
        onPageSizeChange(pageSize);
      }}
      slots={{
        pagination: CustomPagination,
      }}
    />
  );
};

export default ReportTable;
